import { render, staticRenderFns } from "./analyseDetail.vue?vue&type=template&id=06e3a16b&scoped=true"
import script from "./analyseDetail.vue?vue&type=script&lang=js"
export * from "./analyseDetail.vue?vue&type=script&lang=js"
import style0 from "./analyseDetail.vue?vue&type=style&index=0&id=06e3a16b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3a16b",
  null
  
)

export default component.exports